import React from "react";
import clsx from "clsx";
import { Row } from "react-bootstrap";

import styles from "./layout.module.scss";

type FormRowProps = { children?: React.ReactNode; className?: string };

export const FormRow = ({ children, className }: FormRowProps) => {
	return <Row className={clsx(styles.formRow, className)}>{children}</Row>;
};
